import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* getPreExistingTemplate<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.PREEXISTING_TEMPLATE.GET_TEMPLATE + '?sort_by=-updated_at&page=1&per_page=10', action.payload, true, false)
        if (resp?.data?.success) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        action?.onError({ message: e.message, status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getPreExistingTemplate', action: action?.type })
    }
}
